export default __webpack_public_path__ + "static/media/tether-usdt-logo.6dc09781.svg";